import React, {useState} from 'react';
import {Button, Popover, PopoverBody, PopoverHeader} from 'reactstrap';
import {FaPhone} from 'react-icons/fa'


export default function ContactButton({onClick, position, popoverText, popoverHeader, accentColor, secondaryColor}){

    const [popoverOpen, setPopoverOpen] = useState(false)

    function renderPopover() {
        if(popoverText){
            return (
                <>
                    <PopoverHeader>{popoverHeader}</PopoverHeader>            
                    <PopoverBody>{popoverText}</PopoverBody>
                </>
            );
        } else {
            return (
                <>                    
                    <PopoverHeader>{popoverHeader}</PopoverHeader>
                </>
            );
        }        
    }

    return(
        <>
        <Button type="button" id="leaveContactButton" 
            onMouseOver={() => setPopoverOpen(true)} 
            onMouseOut={() => setPopoverOpen(false)}
            onClick={() => onClick()} size="xl" 
            className={"btn-circle floating-button " + position} style={{backgroundColor: accentColor}}>            
            
            <FaPhone color={secondaryColor}></FaPhone>
        
        </Button>
        <div className={"floating-button circle " + position} style={{backgroundColor: accentColor}}></div>          
        <Popover placement="top" isOpen={popoverOpen} target="leaveContactButton">            
            {renderPopover()}            
        </Popover>       
         
        </>
    )
}